// Currency configurations extracted from the original project
export const CURRENCY_CONFIG = {
  cny: { name: '人民币', logo: `/images/icons/cny.svg` },
  aud: { name: '澳元', logo: `/images/icons/aud.svg` },
  usd: { name: '美元', logo: `/images/icons/usd.svg` },
  eur: { name: '欧元', logo: `/images/icons/eur.svg` },
  sgd: { name: '新元', logo: `/images/icons/sgd.svg` },
  hkd: { name: '港元', logo: `/images/icons/hkd.svg` },
  nzd: { name: '纽元', logo: `/images/icons/nzd.svg` },
  cad: { name: '加元', logo: `/images/icons/cad.svg` },
  gbp: { name: '英镑', logo: `/images/icons/gbp.svg` },
  usdt: { name: 'USDT', logo: `/images/icons/usdt.svg` },
  audd: { name: 'AUDD', logo: `/images/icons/audd.png` },
  usdc: { name: 'USDC', logo: `/images/icons/usdc.svg` },
  btc: { name: 'BTC', logo: `/images/icons/btc.svg` },
  eth: { name: 'ETH', logo: `/images/icons/eth.svg` },
  myr: { name: '马来西亚令吉特', logo: `/images/icons/myr.svg` },
};
// Trading pairs configuration
export const TRADING_PAIRS = {
  'usdt-cny': { priceAccuracy: 4, margin: 0.0264 },
  'usdt-aud': { priceAccuracy: 4, margin: 0.0264 },
  'usdt-usd': { priceAccuracy: 4, margin: 0.0264 },
  'usdc-cny': { priceAccuracy: 4, margin: 0.0264 },
  'usdc-aud': { priceAccuracy: 4, margin: 0.0264 },
  'usdc-usd': { priceAccuracy: 4, margin: 0.0264 },
  'audd-usdt': {
    priceAccuracy: 4,
    margin: 0.0264,
    dependencies: ['aud-usdt', 'aud-cny', 'usdt-cny'],
  },
  'audd-aud': { priceAccuracy: 4, margin: 0.0264 },
  'audd-cny': { priceAccuracy: 4, margin: 0.0264, dependencies: ['aud-cny'] },
  'aud-cny': { priceAccuracy: 4, margin: 0.0264 },
  'aud-usdt': { priceAccuracy: 4, margin: 0.0264 },
  'aud-usd': { priceAccuracy: 4, margin: 0.0264 },
  'aud-usdc': { priceAccuracy: 4, margin: 0.0264 },
  'aud-sgd': { priceAccuracy: 4, margin: 0.0264 },
  'aud-hkd': { priceAccuracy: 4, margin: 0.0264 },
  'aud-myr': { priceAccuracy: 4, margin: 0.0264 },
  'btc-aud': { priceAccuracy: 4, margin: 0.0264 },
  'eth-aud': { priceAccuracy: 4, margin: 0.0264 },
  'audd-usd': { priceAccuracy: 4, margin: 0.0264, dependencies: ['aud-usd'] },
  'audd-sgd': { priceAccuracy: 4, margin: 0.0264, dependencies: ['aud-sgd'] },
  'audd-hkd': { priceAccuracy: 4, margin: 0.0264, dependencies: ['aud-hkd'] },
  'audd-myr': { priceAccuracy: 4, margin: 0.0264, dependencies: ['aud-myr'] },
  'audd-usdc': { priceAccuracy: 4, margin: 0.0264, dependencies: ['aud-usdc'] },
  'btc-audd': { priceAccuracy: 4, margin: 0.0264, dependencies: ['btc-aud'] },
  'eth-audd': { priceAccuracy: 4, margin: 0.0264, dependencies: ['eth-aud'] },
};

// List of supported tickers
export const SUPPORTED_TICKERS = Object.keys(TRADING_PAIRS);

// Crypto to fiat pairs (for display purposes)
export const CRYPTO_FIAT_PAIRS = [
  'usdt-cny',
  'usdt-aud',
  'usdt-usd',
  'usdc-cny',
  'usdc-aud',
  'usdc-usd',
  'audd-usdt',
  'audd-usdc',
  'audd-aud',
  'audd-cny',
  'audd-usd',
  'audd-sgd',
  'audd-hkd',
  'audd-myr',
  'btc-audd',
  'eth-audd',
];

/**
 * Split ticker into symbol array
 * @param {string} ticker - e.g., 'usdt-cny'
 * @returns {string[]} - e.g., ['usdt', 'cny']
 */
export const tickerToSymbols = ticker => {
  return ticker.split('-');
};

/**
 * Get display name for ticker
 * @param {string} ticker - e.g., 'usdt-cny'
 * @returns {string} - e.g., 'USDT/人民币'
 */
export const getTickerDisplayName = ticker => {
  const symbols = tickerToSymbols(ticker);
  return symbols
    .map(symbol =>
      symbol in CURRENCY_CONFIG
        ? CURRENCY_CONFIG[symbol].name
        : symbol.toUpperCase(),
    )
    .join('/');
};

/**
 * Get currency info by symbol
 * @param {string} symbol - e.g., 'usdt'
 * @returns {object} - currency config object
 */
export const getCurrencyInfo = symbol => {
  return (
    CURRENCY_CONFIG[symbol] || {
      name: symbol.toUpperCase(),
      logo: `/images/icons/${symbol}.svg`,
    }
  );
};
